import { create } from "zustand"
import { TREATMENT_CASE_SORT, type TreatmentCaseSort } from "@/shared/types/type/treatment"

interface TreatmentCaseUIStore {
  selectedCategoryId: number
  setSelectedCategoryId: (selectedCategoryId: number) => void
  selectedSubjectId: number
  setSelectedSubjectId: (selectedSubjectId: number) => void
  selectedSort: TreatmentCaseSort
  setSelectedSort: (selectedSort: TreatmentCaseSort) => void
}

const useTreatmentCaseUIStore = create<TreatmentCaseUIStore>((set) => ({
  selectedCategoryId: 0,
  setSelectedCategoryId: (selectedCategoryId: number) => set({ selectedCategoryId }),
  selectedSubjectId: 0,
  setSelectedSubjectId: (selectedSubjectId: number) => set({ selectedSubjectId }),
  selectedSort: TREATMENT_CASE_SORT.VIEW_COUNT_DESC,
  setSelectedSort: (selectedSort: TreatmentCaseSort) => set({ selectedSort }),
}))

export default useTreatmentCaseUIStore

